/**
 * Converts a date string (YYYY-MM-DD) to UTC ISO string
 * @param {string} dateString - Date string in YYYY-MM-DD format
 * @returns {string|null} UTC ISO string or null if dateString is empty
 */
export const convertToUTCISOString = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString + 'T00:00:00Z');
    return date.toISOString();
};

/**
 * Formats a date for API submission (YYYY-MM-DD)
 * @param {string|Date} dateValue - Date string or Date object
 * @returns {string|null} YYYY-MM-DD string or null
 */
export const formatDateForAPI = (dateValue) => {
    if (!dateValue) return null;
    const d = new Date(dateValue);
    if (isNaN(d.getTime())) return null;
    return d.toISOString().split('T')[0];
};

/**
 * Formats a date string or Date object to locale date string
 * @param {string|Date} dateString - Date string or Date object
 * @returns {string} Formatted date string or 'N/A' if invalid
 */
export const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString();
};

/**
 * Formats a number as currency
 * @param {number} amount - Amount to format
 * @param {string} currency - Currency symbol (default '$')
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (amount, currency = '$') => {
    if (amount === null || amount === undefined) return `${currency}0.00`;
    return `${currency}${parseFloat(amount).toFixed(2)}`;
};
